import initialState from './ReservationsInitialState';
import reducers from './ReservationsReducer';

export default {
  initialState,
  reducers,
};
